import React from 'react'
import Head from 'next/head'
import Contact from '../../src/pages/website/Contact/Contact'
import CommonHead from '../_head'

export default () => (
  <>
    <Head>
      <title>Need the Advice to Scale Your Business | Reach Out to Martin's Team</title>
      <CommonHead description="Contact us for general inquiries about Martin Warner's Entrepreneur Seminar Program, events, coaching, and any other questions you might have." />
    </Head>

    <Contact />
  </>
)
